module.exports = __webpack_public_path__ + "static/media/raycast_banner.20d3f41a.png";